export default[
    {
        path: '/orderview',
        name: 'orderview',
        redirect:'/orderview/myorders',
        component: () => import('@/views/ordercenter/orderview.vue'),
        children: [
            {
              path: 'myorders',
              name: 'myorders',
              component: () => import('@/views/ordercenter/myorders.vue'),
            },
            {
                path: 'mypays',
                name: 'mypays',
                component: () => import('@/views/ordercenter/mypays.vue'),
            },
            {
                path: 'mycoupon',
                name: 'mycoupon',
                component: () => import('@/views/ordercenter/mycoupon.vue'),
            },
            {
                path: 'myextend',
                name: 'myextend',
                component: () => import('@/views/ordercenter/myextend.vue'),
            },
            {
                path: 'extendfriends',
                name: 'extendfriends',
                component: () => import('@/views/ordercenter/extendfriends.vue'),
            },
            {
                path: 'extendorder',
                name: 'extendorder',
                component: () => import('@/views/ordercenter/extendorder.vue'),
            },
            {
                path: 'extenddetailed',
                name: 'extenddetailed',
                component: () => import('@/views/ordercenter/extenddetailed.vue'),
            }
        ]
    },
    
]